<template>
  <v-form
    ref="replacementForm"
    @submit.prevent="submitForm"
  >
    <v-row>
      <v-col
        cols="6"
        class="pb-0"
      >
        <label class="input-label">Data rozpoczęcia *</label>
        <v-menu
          ref="fromDatePicker"
          v-model="isFromDatePickerShown"
          :close-on-content-click="false"
          v-bind="staticData.props.datePickerMenu"
        >
          <template #activator="{ on, attrs }">
            <div v-on="on">
              <v-text-field
                :value="formData.from | displayDate"
                :rules="isFromDatePickerShown
                  ? [] : [staticData.rules.required, allowedFromDate]"
                persistent-hint
                v-bind="{...attrs, ...staticData.props.shortTextField}"
                height="40"
                readonly
                placeholder="Wybierz datę"
                class="input-calendar"
                append-icon="mdi-calendar-month-outline"
              />
            </div>
          </template>
          <v-date-picker
            v-model="formData.from"
            :min="replacement && replacement.createdAt
              ? new Date(replacement.createdAt).toISOString().substring(0,10)
              : new Date().toISOString().substring(0,10)"
            :max="formData.to"
            v-bind="staticData.props.datePicker"
            @input="isFromDatePickerShown = false"
          />
        </v-menu>
      </v-col>
      <v-col
        cols="6"
        class="pb-0"
      >
        <label class="input-label">Data zakończenia *</label>
        <v-menu
          ref="toDatePicker"
          v-model="isToDatePickerShown"
          :close-on-content-click="false"
          v-bind="staticData.props.datePickerMenu"
        >
          <template #activator="{ on, attrs }">
            <div v-on="on">
              <v-text-field
                :value="formData.to | displayDate"
                :rules="isToDatePickerShown
                  ? [] : [staticData.rules.required, allowedToDate]"
                persistent-hint
                v-bind="{...attrs, ...staticData.props.shortTextField}"
                height="40"
                readonly
                placeholder="Wybierz datę"
                class="input-calendar"
                append-icon="mdi-calendar-month-outline"
              />
            </div>
          </template>
          <v-date-picker
            v-model="formData.to"
            :min="formData.from"
            v-bind="staticData.props.datePicker"
            @input="isToDatePickerShown = false"
          />
        </v-menu>
      </v-col>
      <v-col
        cols="12"
        class="pt-0"
      >
        <label class="input-label">Zastępcy *</label>
        <v-autocomplete
          v-model="formData.userIds"
          :items="usersSimplifiedList"
          :rules="[staticData.rules.required]"
          placeholder="Wybierz zastępców"
          multiselect
          :item-text="(item) => `${item.firstName} ${item.lastName}`"
          item-value="id"
          multiple
          :hide-details="false"
          height="40"
          v-bind="staticData.props.select"
        >
          <template #selection="{ item, index }">
            <AppMultiselectChoices
              :visible-items="2"
              :index="index"
              :array-length="formData.userIds.length"
              :label="`${item.firstName} ${item.lastName}`"
            />
          </template>
          <template #item="{item}">
            {{ `${item.firstName} ${item.lastName}` }}
            <v-spacer />
            <span
              v-if="item.replaced"
              class="error--text"
            >(nieobecny)</span>
          </template>
        </v-autocomplete>
      </v-col>
    </v-row>

    <v-btn
      class="custom-submit-button mt-4"
      color="primary"
      type="submit"
    >
      {{ replacement ? 'Zapisz' : 'Dodaj' }} zastępstwo
    </v-btn>
  </v-form>
</template>

<script>
import AppMultiselectChoices from '@/components/UI/AppMultiselectChoices.vue';
import { mapState, mapActions } from 'vuex';
import props from '@/helpers/componentsProps';
import rules from '@/helpers/validators';
import dayjs from 'dayjs';

export default {
  props: {
    user: {
      type: Object,
      default: null,
    },
    replacement: {
      type: Object,
      default: null,
    },
  },

  components: {
    AppMultiselectChoices,
  },

  data() {
    return {
      staticData: {
        props,
        rules,
      },
      isFromDatePickerShown: false,
      isToDatePickerShown: false,
      formData: {
        to: null,
        from: new Date().toISOString().substring(0, 10),
        userIds: [],
      },
    };
  },

  computed: {
    ...mapState('users', [
      'usersSimplifiedList',
    ]),
  },

  created() {
    this.fetchSimplifiedUsersList();
    if (this.replacement) {
      this.formData = {
        ...this.replacement,
        userIds: this.replacement.users.map((user) => user.id),
      };
    } else {
      this.formData.userId = this.user.id;
    }
  },

  methods: {
    ...mapActions('users', [
      'createReplacement',
      'updateReplacement',
      'fetchSimplifiedUsersList',
    ]),

    ...mapActions('dialog', [
      'clearDialog',
    ]),

    allowedFromDate() {
      const date = +dayjs(this.formData.from);
      const today = +dayjs().startOf('date');
      const max = this.formData.to ? +dayjs(this.formData.to) : false;
      if (date < today) return 'Wybrano przeszłą datę';
      if (max && date > max) return 'Zastępstwo rozpoczyna się przed jego zakończeniem';
      return !!date;
    },

    allowedToDate() {
      const date = +dayjs(this.formData.to);
      const today = +dayjs().startOf('date');
      const min = this.formData.from ? +dayjs(this.formData.from) : false;
      if (date < today) return 'Wybrano przeszłą datę';
      if (min && date < min) return 'Zastępstwo kończy się przed jego rozpoczęciem';
      return !!date;
    },

    submitForm() {
      if (this.$refs.replacementForm.validate()) {
        const submitMethod = this.replacement ? this.updateReplacement : this.createReplacement;
        submitMethod(this.formData)
          .then(() => {
            this.clearDialog();
          });
      }
    },
  },

};
</script>
